import React, { useEffect, useState } from 'react';
import './../home.scss';
import './../trending.scss';
import Loading from '../../../components/Loading';
import { useContentLibraryManager } from "../../../hooks/useManagers";

const TrendingContent = () => {
  const contentMgr = useContentLibraryManager();
  const [trendingContent, setTrendingContent] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTrendingContent = async () => {
      try {
        if (contentMgr) {
          const result = await contentMgr.TrendingContent();
          if (result.Success) {
            setTrendingContent(result);
          } else {
            setError('Failed to fetch trending content.');
          }
        }
      } catch (err) {
        setError(`Error fetching trending content: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchTrendingContent();
  }, [contentMgr]);

  useEffect(() => {
    if (trendingContent) {
      const imageSet = trendingContent.Items?.slice(0, 3);
      setImages(imageSet);
    }
  }, [trendingContent]);

  // 4.4 audit finding (aa-compliance-home): the "8th Grade English Lesson" and "Elementary
  // Cluster Meeting" videos below are hosted externally on niet.org (a third-party WordPress/
  // video-embed page we don't control), not through this app's own video pipeline. As of this
  // audit, neither page exposes a captions/subtitles track or an audio-description track/
  // transcript alongside its embedded player, and there's no in-house alternative available to
  // swap in today. Since we can't add real caption/description tracks to a page we don't own,
  // and building an in-house re-hosted copy of this third-party content is out of scope for this
  // change, each externally-linked card below carries a visible "Opens in a new tab; captions
  // may not be available" disclosure so users know what to expect before navigating away.
  // Follow-up: flag to the content team as a dependency to either (a) source
  // captioned/described versions from niet.org, or (b) re-host in-house versions through the
  // Content Library pipeline (which does support tracks) once available.
  const EXTERNAL_CAPTION_UNVERIFIED_IDS = new Set([
    '83d33b95-9e2e-4f12-8726-36573db5a270', // 8th Grade English Lesson
    '32a0ea8e-ace9-4e7d-8054-336baf70d7b5', // Elementary Cluster Meeting
  ]);

  const getFreeContentLink = (imageId) => {
    switch (imageId) {
      case 'e8b1f1ea-d178-42c6-b50d-1f871be141f6':
        return 'https://next.eepass.org/learningmodules/1ffc1043-8449-41e9-9fe0-ea36f4e967e9/story_html5.html';
      case '83d33b95-9e2e-4f12-8726-36573db5a270':
        return 'https://www.niet.org/newsroom/show/video/free-ee-pass-resource-video-8th-grade-english-lesson-full-lesson';
      case '32a0ea8e-ace9-4e7d-8054-336baf70d7b5':
        return 'https://www.niet.org/newsroom/show/video/free-ee-pass-resource-video-elementary-cluster-meeting-full-meeting';
      default:
        return null;
    }
  }

  return (
    <div className='trending-content' role="region" aria-label="Trending Content">
      {/* 7.5 heading-order fix: was a plain <div> (not announced at all to "navigate by
          heading" screen reader users). Promoted to <h2> so this section nests correctly under
          the page's single <h1> (Main.js hero), alongside the other section headings. */}
      <h2 className='trending-content-header'>
        {/* Trending EE PASS Content */}
        Explore Our Coaching Hub
      </h2>
      {loading ? (
        <div className='loading-icon-container'>
          <Loading size={'2.25rem'} />
        </div>
      ) : error ? (
        <div className='error-message'>
          {error}
        </div>
      ) : (
        <div className="trending-img-container">
          {images.map((image) => {
              var link = getFreeContentLink(image.Id);
              return link ? (
              <div key={image.Id} className='img-div-header'>
                <a href={link} target="_blank" rel="noopener noreferrer">
                <img src={image.ThumbnailFile?.FileUrl} alt="{image.Title}" />
                <div className='trending-img-title'>{image.Title}</div>
                </a>
              </div>
              ) : (
              <div key={image.Id} className='img-div-header'>
                <img src={image.ThumbnailFile?.FileUrl} alt={image.Title} />
                <div className='trending-img-title'>{image.Title}</div>
              </div>
              )
            }
          )}
          <div className='trending-content-disclosure'>
            Videos open in a new tab on niet.org; captions may not be available.
          </div>
        </div>
      )}
    </div>
  );
};

export default TrendingContent;
